import { render } from "./LayoutBase.vue?vue&type=template&id=5e945363&scoped=true&ts=true"
import script from "./LayoutBase.vue?vue&type=script&lang=ts"
export * from "./LayoutBase.vue?vue&type=script&lang=ts"

import "./LayoutBase.vue?vue&type=style&index=0&id=5e945363&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e945363"]])

export default __exports__